// src/pages/procurement/components/SupplierStatementA4.jsx
// Cloned from src/pages/offlineSales/components/CustomerStatementA4.jsx — same
// A4DocumentLayout shape, with statement.supplier in place of statement.customer and the
// procurement transaction-type vocabulary (purchase_order / supplier_payment / debit_note).
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import A4DocumentLayout from '../../../components/common/A4DocumentLayout/A4DocumentLayout';
import { formatDate } from '../../../utils/dateUtils';

const TYPE_LABELS = {
  purchase_order: 'Purchase Order',
  supplier_payment: 'Payment',
  debit_note: 'Debit Note',
};

const SupplierStatementA4 = ({ statement }) => {
  const { t, formatCurrency } = useLocalization();

  if (!statement) return null;

  return (
    <A4DocumentLayout
      title={t('procurement.supplierStatementTitle')}
      subtitle={statement.supplier?.name}
      documentNumber={`${statement.dateFrom ? formatDate(statement.dateFrom) : t('procurement.accountStart')} — ${statement.dateTo ? formatDate(statement.dateTo) : t('procurement.today')}`}
      metaRows={[
        { label: t('procurement.openingBalance'), value: formatCurrency(statement.openingBalance) },
        { label: t('procurement.closingBalance'), value: formatCurrency(statement.closingBalance) },
      ]}
      infoCards={[
        {
          title: t('procurement.supplier'),
          primary: statement.supplier?.name || '—',
          lines: [statement.supplier?.phone && `${t('procurement.phone')}: ${statement.supplier.phone}`].filter(Boolean),
        },
      ]}
      items={{
        columns: [
          { header: t('procurement.date') },
          { header: t('procurement.type') },
          { header: t('procurement.reference') },
          { header: t('procurement.debit'), align: 'right' },
          { header: t('procurement.credit'), align: 'right' },
          { header: t('procurement.balance'), align: 'right' },
        ],
        rows: (statement.transactions || []).map((tx) => [
          new Date(tx.date).toLocaleDateString(),
          TYPE_LABELS[tx.type] || tx.type,
          tx.reference || '—',
          (tx.debit > 0 || tx.type === 'purchase_order') ? formatCurrency(tx.debit) : '—',
          tx.credit > 0 ? formatCurrency(tx.credit) : '—',
          formatCurrency(tx.runningBalance),
        ]),
      }}
      summary={{
        totals: [
          { label: t('procurement.openingBalance'), value: formatCurrency(statement.openingBalance) },
          { label: t('procurement.closingBalance'), value: formatCurrency(statement.closingBalance), variant: 'grand' },
        ],
      }}
      footerText={t('procurement.thankYouMessage')}
      footerNote="This is a computer-generated statement."
    />
  );
};

export default SupplierStatementA4;
